export {
  default,
  LOCAL_NOTIFICATION,
  GLOBAL_NOTIFICATION,
  STICKY_NOTIFICATION,
  DEFAULT_AUTO_HIDE_TIMEOUT as DEFAULT_TIMEOUT,
} from './Notification.js';
